<template>
    <a-card>
        <a-form :layout="formLayout">
            <a-form-item
                label="显示数据条数"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
            >
                <a-input
                    v-model="params.num"
                    style="width: 60px; margin-right: 10px;"
                /><span>条</span>
            </a-form-item>
            <a-form-item
                label="显示数据时间段"
                :label-col="formItemLayout.labelCol"
            >
                <a-radio-group
                    name="radioGroup"
                    style="margin-left: 10px;"
                    v-model="params.type"
                >
                    <a-radio :value="1">今天</a-radio>
                    <a-radio :value="2">近7天</a-radio>
                    <a-radio :value="3">近30天</a-radio>
                    <a-radio :value="4">全部</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item
                label="弹幕默认开关"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
            >
                <a-switch default-checked v-model="params.status" />
            </a-form-item>
            <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
                <a-button @click="submit" type="primary">确认</a-button>
            </a-form-item>
        </a-form>
    </a-card>
</template>

<script>
import { bulletChatConfigindex, bulletChatConfigupdate } from "@/api/manage";
import moment from "moment";
export default {
    data() {
        return {
            formLayout: "horizontal",
            params: {
                num: "",
                status: false,
                type: 4,
            },
            dateloading: false,
        };
    },
    computed: {
        formItemLayout() {
            const { formLayout } = this;
            return formLayout === "horizontal"
                ? { labelCol: { span: 3 }, wrapperCol: { span: 16 } }
                : {};
        },
        buttonItemLayout() {
            const { formLayout } = this;
            return formLayout === "horizontal"
                ? { wrapperCol: { span: 16, offset: 3 } }
                : {};
        },
    },
    mounted() {
        this.initial();
    },
    methods: {
        moment,
        initial() {
            this.askData();
        },
        askData() {
            return bulletChatConfigindex().then((res) => {
                this.params.num = res.result.num;
                this.params.status = +res.result.status === 1;
                this.params.type = res.result.type;
                this.dateloading = true;
            });
        },
        submit() {
            // console.log(this.params);
            let params = {
                num: this.params.num,
                type: this.params.type,
                status: this.params.status ? 1 : 0,
            };
            return bulletChatConfigupdate(params).then(() => {
                this.$message.success("设置成功");
            });
        },
    },
};
</script>
